import script from "./ds-table-cell.vue?vue&type=script&lang=ts&setup=true"
export * from "./ds-table-cell.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__